import React, { useContext, useEffect, useState } from 'react'
import { BottomDiv, ButtonContainer, ButtonDiv, CloseDiv, Container, DimensionsFieldsDiv, FormData, Header, InputData, InputDiv, InputLabel, SelectData, ShortField, TabDiv, TabsDiv, TabText } from './style'
import { fieldsAndValues } from './utils'
import axios from '../../../config/axios'
import { ServicesContext } from '../../../contexts/ServicesContext'
import close from '../../../assets/close-icon.svg'
import plus from '../../../assets/productions/plus.svg'
import disk from '../../../assets/productions/disk.svg'
import { useNavigate } from 'react-router-dom'
import ModalTest from '../../BaseModal'
import SelectStageInService from '../../ProductionFlow/SelectItem/Stage'
import SelectOrderItemInService from '../../ProductionFlow/SelectItem/OrderItem'
import SelectOrderInService from '../../ProductionFlow/SelectItem/Order'
import { X } from 'lucide-react'

export interface ServiceOfProductionType {
  orderId: number
  orderItem: {id: number, product: string}
  stages: {id: number, name: string}[]
  quantity: number
  // material: {id: number, name: string}
}

const CreateOPModal:React.FC = () => {
  const [ service, setService ] = useState<ServiceOfProductionType>({
    orderId: 0,
    orderItem: {id: 0, product: ''},
    stages: [],
    quantity: 0,
    // material: {id: 0, name: ''}
  })
  const navigate = useNavigate()

  const handleSubmitForm = () => {
    const serviceData = {
      orderItemId: service.orderItem.id,
      stages: service.stages.map((s, index) => ({
        stageId: s.id,
        index: index
      })),
      quantity: service.quantity,
    }
    axios.post(`${process.env.REACT_APP_GATEWAY_BASE_URL}/production-flow/service`, serviceData)
      .then(response => {
        navigate('../')
        return
      })
      .catch(error => {
        console.error(error)
      })
  }

  return(
    <ModalTest>
      <Container>
        <Header>
          <h2>Criar ordem de produção</h2>
          <CloseDiv onClick={() => navigate('../')}> <img src={close} /> </CloseDiv>
        </Header>
          <FormData>
            <SelectOrderInService service={service} setService={setService} />
            <SelectOrderItemInService service={service} setService={setService} />
            <div style={{display: 'flex', flexDirection: 'column', gap: '10px'}}>
              <SelectStageInService service={service} setService={setService} />
              <TabsDiv>
                {service.stages.map((s, index) => (
                  <TabDiv key={index}>
                    <TabText>{s.name}</TabText>
                    <X size={16} style={{cursor: 'pointer'}} onClick={() => setService(prev => ({...prev, stages: prev.stages.filter((_, i) => i !== index)}))} />
                  </TabDiv>
                ))}
              </TabsDiv>
            </div>
          </FormData>
          <BottomDiv>
            <ButtonContainer>
              <ButtonDiv onClick={(() => navigate('../'))} className='cancel'>Cancelar</ButtonDiv>
              <ButtonDiv onClick={() => handleSubmitForm()}>
                <img src={plus} /> Cadastrar
              </ButtonDiv>
            </ButtonContainer>
          </BottomDiv>
      </Container>
    </ModalTest>
  )
}

export default CreateOPModal
